import { createSlice } from '@reduxjs/toolkit';

export const experienceSlice = createSlice({
  name: 'experience',
  initialState: {
    ...window.ecom.redux_initial_state.experience,
    initialValues: {},
  },
  reducers: {
    setBookingFormInitialValues: (state, action) => {
      state.initialValues = action.payload;
    },
  },
});

export const { setBookingFormInitialValues } = experienceSlice.actions;
export default experienceSlice.reducer;
